import React from 'react'
import Button from '@mui/material/Button'

type Props = {
  onClick: () => void
}

/**
 * SH-1143 — single primary (dark blue) action that replaces the Knock Status + Add Lead buttons
 * when records at the clicked location are hidden by the active filters. Pressing it removes only
 * the relevant filters to reveal the hidden record(s). Shared by the HERE and MapLibre tooltips.
 */
export function UpdateFiltersButton({ onClick }: Props) {
  return (
    <Button
      variant="contained"
      color="primary"
      fullWidth
      onClick={onClick}
      sx={{ textTransform: 'none' }}
    >
      Update Filters to View Record(s)
    </Button>
  )
}
